module.exports = __webpack_public_path__ + "img/boy-body-front.85964df9.png";